/* Scoped Liberator gallery. No product records or global gallery prototype changes. */
(() => {
  'use strict';
  const script = document.currentScript;
  const gallery = script && script.closest('media-gallery');
  const data = gallery && gallery.querySelector('.js-ca-liberator-preview');
  const scope = new Set(['582949601313', '4448092258381']);
  if (!gallery || !data || !scope.has(data.dataset.productId) || gallery.dataset.caPreviewBound) return;
  gallery.dataset.caPreviewBound = 'true';
  const pid = data.dataset.productId;
  const viewer = gallery.querySelector('.media-viewer');
  const thumbs = gallery.querySelector('.media-thumbs');
  if (!viewer || !thumbs) return;
  const section = gallery.closest('.js-product');
  const originalItems = Array.from(viewer.children);
  const originalThumbs = Array.from(thumbs.children);
  const items = new Map(originalItems.map(item => [item.dataset.mediaId, item]));
  const thumbMap = new Map(originalThumbs.map(item => [item.dataset.mediaId, item]));
  let payload;
  let config;
  let parseError = false;
  try { payload = JSON.parse(data.textContent); config = payload.config; }
  catch (_) { parseError = true; }
  const record = value => value !== null && typeof value === 'object' && !Array.isArray(value);
  const shapeError = parseError || !record(payload) || !record(config)
    || !record(config.maps) || !record(config.variants) || !record(config.catalog)
    || !Array.isArray(config.approvedSupplierURLs) || !config.approvedSupplierURLs.every(url => typeof url === 'string')
    || !Array.isArray(payload.actualVariants) || !Array.isArray(payload.actualMedia);
  const currentVariant = () => {
    const field = section && section.querySelector('form input[name="id"]');
    return field && field.value ? String(field.value) : data.dataset.initialVariant;
  };
  const freshVariants = new Map((Array.isArray(payload?.actualVariants) ? payload.actualVariants : []).filter(record).map(v => [String(v.id), v]));
  const freshMedia = new Map((Array.isArray(payload?.actualMedia) ? payload.actualMedia : []).filter(record).map(m => [String(m.id), m]));
  const basename = src => {
    try { return new URL(src, location.origin).pathname.split('/').pop(); }
    catch (_) { return ''; }
  };
  const altFor = entry => {
    const colour = entry.colour === 'Red' ? 'Merlot' : entry.colour;
    const size = entry.exactSupplierSKU === 'LB1037' ? 'Travel' : entry.exactSupplierSKU === 'LB1071' ? 'King' : 'Queen';
    return `Liberator Fascinator ${size} ${colour} throw ${entry.role} view (${entry.exactSupplierSKU})`;
  };
  if (!shapeError) {
    for (const [key, entry] of Object.entries(config.catalog)) {
      if (!record(entry) || !Array.isArray(entry.allowedVariants) || entry.productId !== pid || entry.kind === 'native') continue;
      if (!key.startsWith('mock:') || !config.approvedSupplierURLs.includes(entry.src)) continue;
      const item = document.createElement('li');
      item.className = 'media-viewer__item';
      item.dataset.mediaId = key;
      item.dataset.mediaType = 'image';
      item.dataset.caPreviewOnly = 'true';
      const frame = document.createElement('div');
      frame.className = 'media relative';
      frame.style.paddingTop = '100%';
      const link = document.createElement('a');
      link.href = entry.src;
      link.target = '_blank';
      link.rel = 'noopener';
      link.style.cssText = 'position:absolute;inset:0;display:block';
      link.setAttribute('aria-label', `Open full-size ${altFor(entry)}`);
      const image = document.createElement('img');
      image.className = 'product-image img-fit img-fit--contain w-full';
      image.src = entry.src;
      image.alt = altFor(entry);
      image.loading = 'lazy';
      image.width = 2000;
      image.height = 2000;
      image.addEventListener('error', () => fail('supplier-image-unavailable', currentVariant()));
      link.append(image);
      frame.append(link);
      item.append(frame);
      item.style.display = 'none';
      viewer.append(item);
      items.set(key, item);
      const thumb = document.createElement('li');
      thumb.className = 'media-thumbs__item';
      thumb.dataset.mediaId = key;
      thumb.dataset.caPreviewOnly = 'true';
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'media-thumbs__btn media relative w-full';
      button.style.paddingTop = '100%';
      button.setAttribute('aria-controls', viewer.id);
      const text = document.createElement('span');
      text.className = 'visually-hidden';
      text.textContent = `Load ${altFor(entry)} in gallery view`;
      const thumbImage = image.cloneNode();
      thumbImage.className = 'img-fit img-fit--contain w-full';
      button.append(text, thumbImage);
      thumb.append(button);
      thumb.style.display = 'none';
      thumbs.append(thumb);
      thumbMap.set(key, thumb);
    }
  }
  const nativePrimary = id => {
    const actual = freshVariants.get(String(id));
    return actual && actual.primary ? String(actual.primary) : String(data.dataset.initialPrimary || '');
  };
  function show(keys) {
    for (const node of items.values()) { node.style.display = 'none'; node.classList.remove('is-current-variant'); }
    for (const node of thumbMap.values()) node.style.display = 'none';
    keys.forEach((key, index) => {
      const item = items.get(key);
      const thumb = thumbMap.get(key);
      if (!item || !thumb) return;
      viewer.append(item);
      thumbs.append(thumb);
      item.style.display = '';
      thumb.style.display = '';
      if (index === 0) item.classList.add('is-current-variant');
    });
    const controls = gallery.querySelector('.media-ctrl');
    if (controls) controls.hidden = keys.length < 2;
    const thumbContainer = gallery.querySelector('.media-gallery__thumbs');
    if (thumbContainer) thumbContainer.hidden = keys.length < 2;
    if (gallery.viewer) {
      gallery.setVisibleItems();
      if (keys.length > 1 && !gallery.caPreviewListeners) {
        gallery.addListeners();
        gallery.caPreviewListeners = true;
      }
      gallery.currentItem = null;
      gallery.currentIndex = 0;
      gallery.viewerItemOffset = keys.length > 1 ? items.get(keys[1]).offsetLeft - items.get(keys[0]).offsetLeft : 1;
      if (keys.length) gallery.customSetActiveMedia(items.get(keys[0]), true);
      else { viewer.scrollLeft = 0; if (gallery.counterCurrent) gallery.counterCurrent.textContent = '0'; }
    }
  }
  function fail(reason, id, retainPrimary = true) {
    gallery.dataset.caPreviewState = 'ineligible';
    gallery.dataset.caPreviewReason = reason;
    const primary = nativePrimary(id);
    const node = items.get(primary);
    const safe = retainPrimary && node && !node.dataset.caPreviewOnly ? [primary] : [];
    show(safe);
    const status = gallery.querySelector('.media-gallery__status');
    if (status) { status.textContent = 'Additional images are unavailable.'; status.setAttribute('aria-hidden', 'false'); }
    return false;
  }
  function apply(id, eventVariant) {
    id = String(id || '');
    if (shapeError) return fail('invalid-map', id);
    const map = config.maps[pid];
    const variant = config.variants[id];
    const actual = freshVariants.get(id);
    const row = record(map) && record(map.variants) && map.variants[id];
    if (!record(map) || map.schema !== 1 || map.productId !== pid) return fail('invalid-map', id);
    if (!record(variant) || !actual || !record(row) || variant.productId !== pid) return fail('unknown-variant', id);
    const primary = nativePrimary(id);
    if (row.nativePrimary !== primary || variant.nativePrimary !== primary || actual.sku !== variant.sku
      || (eventVariant && String(eventVariant.featured_media && eventVariant.featured_media.id || '') !== primary)) return fail('changed-native-primary', id);
    if (!Array.isArray(row.media) || !row.media.length) return fail('missing-variant-set', id);
    const keys = [...new Set([primary, ...row.media])];
    for (const key of keys) {
      const entry = config.catalog[key];
      if (!record(entry) || entry.productId !== pid || !items.has(key) || !thumbMap.has(key)) return fail('missing-media', id);
      if (entry.colour !== variant.colour || !Array.isArray(entry.allowedVariants) || !entry.allowedVariants.includes(id)) return fail('unapproved-variant-or-colour', id);
      if (entry.kind === 'native') {
        const media = freshMedia.get(key);
        if (!media || basename(media.src) !== basename(entry.src)) return fail('changed-native-media', id);
      } else if (!key.startsWith('mock:') || !config.approvedSupplierURLs.includes(entry.src)) return fail('unapproved-supplier-url', id);
    }
    gallery.dataset.caPreviewState = 'eligible';
    delete gallery.dataset.caPreviewReason;
    gallery.dataset.caPreviewVariant = id;
    show(keys);
    return true;
  }
  /* These own-instance methods are installed before the deferred native custom element upgrades. */
  gallery.removeAttribute('data-media-grouping-enabled');
  const gate = gallery.__caGate;
  gallery.init = function () {
    if (gate && gate.initialised) return;
    const proto = Object.getPrototypeOf(this);
    if (typeof proto.init !== 'function') return;
    if (gate) {
      gate.initialised = true;
      clearTimeout(gate.timer);
      section?.removeEventListener('on:variant:change', gate.capture, true);
    }
    const requested = new URL(location.href).searchParams.get('variant');
    const select = () => gate?.hasEvent ? this.onVariantChange(gate.latestEvent) : apply(requested || data.dataset.initialVariant);
    select();
    proto.init.call(this);
    this.caPreviewListeners = this.visibleItems && this.visibleItems.length > 1;
    this.dataset.caGateState = 'ready';
    select();
  };
  gallery.handleResize = function (...args) {
    if (this.visibleItems && this.visibleItems.length > 1) Object.getPrototypeOf(this).handleResize.apply(this, args);
  };
  gallery.handleScroll = function (...args) {
    if (this.visibleItems && this.visibleItems.length > 1) Object.getPrototypeOf(this).handleScroll.apply(this, args);
  };
  gallery.onVariantChange = function (event) {
    const variant = event.detail && event.detail.variant;
    if (event.detail && Object.prototype.hasOwnProperty.call(event.detail, 'variant') && !variant) {
      fail('no-selected-variant', '', false);
      return;
    }
    apply(variant && variant.id || currentVariant(), variant);
  };
  gallery.customSetActiveMedia = function (item, ...args) {
    if (!item || !this.visibleItems || !this.visibleItems.includes(item)) return;
    Object.getPrototypeOf(this).customSetActiveMedia.call(this, item, ...args);
    const status = this.liveRegion;
    if (status && this.dataset.caPreviewState === 'eligible') {
      status.textContent = `Image ${this.currentIndex + 1} of ${this.visibleItems.length}. ${item.querySelector('img')?.alt || ''}`;
      status.setAttribute('aria-hidden', 'false');
    }
  };
  if (!gate) {
    fail('missing-instance-gate', data.dataset.initialVariant);
  } else {
    gate.start = () => gallery.init();
    if (customElements.get('media-gallery')) gallery.init();
  }
})();
